/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUsdInvite.vue?vue&type=template&id=894cd3e8&scoped=true"
import script from "./popUsdInvite.vue?vue&type=script&lang=js"
export * from "./popUsdInvite.vue?vue&type=script&lang=js"
import style0 from "./popUsdInvite.vue?vue&type=style&index=0&id=894cd3e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894cd3e8",
  null
  
)

export default component.exports